import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { resolveValue } from '@lvflanders/bar';
import { resolveValue$ } from '@lvflanders/bar-ng';

// @deprecated Don't use callbacks or observable properties.
/** Controls helper used in html. */
@Injectable({ providedIn: 'root' })
export class _BarControlsHelper {
    /**
     * Will get the value or execute the function to get the value.
     * @param value
     */
    resolveValue(value: any | (() => any)): any {
        return resolveValue(value);
    }

    /**
     * Will return an Observable based on a value which can be of different types.
     * @param value
     */
    resolveValue$(value: Observable<any> | Promise<any> | any | (() => any)): Observable<any> {
        return resolveValue$(value);
    }

    iterateObject(obj) {
        return Object.keys(resolveValue(obj));
    }
}
